import { render, staticRenderFns } from "./MainTabbar.vue?vue&type=template&id=cc035f10&scoped=true&"
import script from "./MainTabbar.vue?vue&type=script&lang=ts&"
export * from "./MainTabbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc035f10",
  null
  
)

export default component.exports